import { ref, computed } from "vue";
import { defineStore } from "pinia";
import store2 from "store2";
import mixpanelService from "@/plugin/mixpanel";

export const useUserInfoStore = defineStore("userInfo", () => {
  const localInfo = store2.get("userInfo");
  const userInfo = ref(localInfo || {});
  
  // 如果本地有用户信息，自动 identify
  if (localInfo && (localInfo.id || localInfo.phone)) {
    const userId = localInfo.id || localInfo.phone;
    // 构建用户属性
    const userProperties = {
      name: localInfo.name,
      phone: localInfo.phone,
      email: localInfo.email,
      // 可以根据需要添加更多属性
    };
    mixpanelService.identify(userId, userProperties);
  }

  const clearUserInfo = () => {
    // Mixpanel reset 在清除用户信息之前
    mixpanelService.reset();
    
    userInfo.value = {};
    store2.remove("userInfo");
  };
  const setUserInfo = (newUserInfo: any) => {
    userInfo.value = newUserInfo;

    // localStorage 存储用户信息
    store2.set("userInfo", newUserInfo);
    
    // Mixpanel identify 用户
    if (newUserInfo && (newUserInfo.id || newUserInfo.phone)) {
      const userId = newUserInfo.id || newUserInfo.phone;
      // 构建用户属性
      const userProperties = {
        name: newUserInfo.name,
        phone: newUserInfo.phone,
        email: newUserInfo.email,
        // 可以根据需要添加更多属性
      };
      mixpanelService.identify(userId, userProperties);
    }
  };
  // 修改用户信息中的某个属性（比如修改 name 或 token）
  const updateUserInfoProperty = (
    property: string,
    value: any,
    callback: Function
  ) => {
    userInfo.value[property] = value; // 更新 userInfo 中的属性
    store2.set("userInfo", userInfo.value); // 更新 localStorage 中的值
    callback(userInfo); // 调用回调
  };

  return { userInfo, clearUserInfo, setUserInfo, updateUserInfoProperty };
});
